import { z } from 'zod'

// Schema tổng hợp cho các thao tác xác thực
const authSchema = z.object({
  name: z
    .string()
    .min(3, { message: 'Username must be at least 3 characters' })
    .max(30, { message: 'Username cannot exceed 30 characters' }),
  email: z.string(),
  password: z
    .string()
    .min(6, { message: 'Password must be at least 6 characters' })
    .max(50, { message: 'Password cannot exceed 50 characters' }),

  userType: z.string(),
})

export const registerSchema = authSchema.pick({
  name: true,
  email: true,
  password: true,
  userType: true,
})

export const loginSchema = authSchema.pick({
  email: true,
  password: true,
})

export const forgotPasswordSchema = authSchema.pick({
  email: true,
})

// Types for each form
export type RegisterRequest = z.infer<typeof registerSchema>
export type LoginRequest = z.infer<typeof loginSchema>
export type ForgotPasswordRequest = z.infer<typeof forgotPasswordSchema>
// Define Zod schema for validation
export const searchSchema = z.object({
  search_q: z.string(),
  cate_code: z.string(),
})

// Infer the TypeScript types from the Zod schema
export type SearchFormValues = z.infer<typeof searchSchema>
